/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { SET_CONTINUE_TO_EXTERNAL_LINK } from '../constants';

const INITIALSTATE = {
    externalLinkData: { id: '', url: '', title: '' },
};

const continueToExternalLink = (state = INITIALSTATE, action) => {
    const st = { ...state };
    switch (action.type) {
        case SET_CONTINUE_TO_EXTERNAL_LINK:
            st.externalLinkData = action.payload;
            return st;
        default:
            return state;
    }
};

export default continueToExternalLink;
